import {
  IntegrationCategoryIdSchema,
  type IntegrationCategoryId,
} from "@jurni/schemas";
import {
  createSerializer,
  parseAsBoolean,
  parseAsString,
  parseAsStringLiteral,
} from "nuqs/server";

const INTEGRATIONS_PATH = "/settings/integrations";

/**
 * The integrations page's URL state, read by the server page and the browser alike. `tab` is a category
 * id, and the All tab is its absence. `integration` names the open integration; the page treats ids
 * outside the catalog as none, which keeps the catalog out of every bundle that builds a link here.
 * `connected` marks a return from an authorization, so the page can confirm the new connection.
 */
export const integrationsSearchParams = {
  q: parseAsString.withDefault(""),
  tab: parseAsStringLiteral(IntegrationCategoryIdSchema.options),
  integration: parseAsString,
  connected: parseAsBoolean.withDefault(false),
};

const serialize = createSerializer(integrationsSearchParams);

export const integrationsHref = ({
  q,
  tab,
}: {
  q?: string;
  tab?: IntegrationCategoryId;
} = {}) => serialize(INTEGRATIONS_PATH, { q: q?.trim(), tab });

export const integrationDetailHref = (id: string) =>
  serialize(INTEGRATIONS_PATH, { integration: id });

export const integrationConnectedHref = (id: string) =>
  serialize(INTEGRATIONS_PATH, { integration: id, connected: true });
